export const isCCCD = (s: string) => /^\d{12}$/.test(s);
export const isCMND = (s: string) => /^\d{9}$/.test(s);
export const isVNPassport = (s: string) => /^[A-Z]\d{7}$/.test(s);